import useSmartQueryClient from "@/hooks/useSmartQueryClient";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";

export function useInviteUser() {
  const smartQueryClient = useSmartQueryClient();

  return useMutation({
    mutationFn: ({
      first_name,
      last_name,
      email,
    }: {
      first_name: string;
      last_name: string;
      email: string;
    }) =>
      axios.post("/user/invite", { first_name: first_name, last_name: last_name, email: email }),
    onSuccess: () => {
      smartQueryClient.invalidateQueries(["team"]);
    },
  });
}
